import React from "react";
import { Link } from "react-router-dom";
import { useNav } from "../context/NavContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "Our Story" },
  { to: "/rooms", label: "Our Rooms" },
  { to: "/peakroom", label: "— The Peak" },
  { to: "/peakfamily", label: "— The Peak Family" },
  { to: "/foresttriple", label: "— Forest Triple" },
  { to: "/forestdouble", label: "— Forest Double" },
  { to: "/foresttwin", label: "— Forest Twin" },
  { to: "/gallery", label: "Browse the Gallery" },
  { to: "/experiences", label: "Experiences" },
  { to: "/cookingclass", label: "— Cooking Class" },
  { to: "/teafactoryvisits", label: "— Tea Factories" },
  { to: "/hanthanarange", label: "— Hanthana Range" },
  { to: "/pekoe", label: "— The Pekoe Trail" },
  { to: "/contact", label: "Reach Out to Us" },
];

function MobileNav() {
  const { mobileOpen, closeMobile } = useNav();

  return (
    <div className={`mobile-nav__wrapper${mobileOpen ? " expanded" : ""}`}>
      <div
        className="mobile-nav__overlay"
        onClick={closeMobile}
        role="presentation"
      />
      <div className="mobile-nav__content">
        <button
          type="button"
          className="mobile-nav__close"
          aria-label="Close menu"
          onClick={closeMobile}
        >
          <span />
          <span />
        </button>
        <nav className="mobile-nav__menu">
          <ul className="main-menu__list">
            {links.map((item) => (
              <li key={item.to}>
                <Link to={item.to} onClick={closeMobile}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <Link
          to="/contact"
          className="villoz-btn"
          onClick={closeMobile}
          style={{ marginTop: 24, display: "inline-flex" }}
        >
          <i>Stay With Us</i>
          <span>Stay With Us</span>
        </Link>
      </div>
    </div>
  );
}

export default MobileNav;
